import { render, staticRenderFns } from "./contadorLaureano.vue?vue&type=template&id=2d40abdc&scoped=true"
import script from "./contadorLaureano.vue?vue&type=script&lang=js"
export * from "./contadorLaureano.vue?vue&type=script&lang=js"
import style0 from "./contadorLaureano.vue?vue&type=style&index=0&id=2d40abdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40abdc",
  null
  
)

export default component.exports